import React, { useState, useEffect } from 'react';
import logo from '../image/LogoM.png';
import './SplashScreen.css';

const SplashScreen = ({ onFinish, duration = 2500 }) => {
  const [exiting, setExiting] = useState(false);

  useEffect(() => {
    let doneTimer;
    const hideTimer = setTimeout(() => {
      setExiting(true);
      doneTimer = setTimeout(() => onFinish?.(), 400);
    }, duration);
    return () => {
      clearTimeout(hideTimer);
      clearTimeout(doneTimer);
    };
  }, [duration, onFinish]);

  return (
    <div className={`splash-screen ${exiting ? 'splash-exit' : ''}`}>
      <div className="splash-content">
        <img src={logo} alt="Millix Logo" className="splash-logo" />
      </div>
    </div>
  );
};

export default SplashScreen;
